import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

export const DlsWrapper = ({ children, dlsUrl }) => (
  <Fragment>
    <Helmet>
      <link rel="stylesheet" href={dlsUrl} />
    </Helmet>
    {children}
  </Fragment>
);

DlsWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  dlsUrl: PropTypes.string.isRequired,
};

export const Dls6Wrapper = ({ children }) => (
  <DlsWrapper dlsUrl="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.5/package/dist/6.25.5/styles/dls.min.css">
    {children}
  </DlsWrapper>
);

Dls6Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export const Dls7Wrapper = ({ children }) => (
  <DlsWrapper dlsUrl="https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.8.0/stylesheets/dls-max.min.css">
    {children}
  </DlsWrapper>
);

Dls7Wrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
